export enum AssetTypes {
  AGRICOBOT = 'Agricobot',
  AGRICOBOT_COMPANION = 'Agricobot Companion',
  UNKNOWN = 'Unknown',
}
